{
  "generatedAt": "2026-06-11T03:16:00.023Z",
  "source": {
    "type": "official_naver_lounge",
    "loungeId": "Dragon_Village3",
    "eventFeedIds": [
      7715965,
      7745058,
      7776586
    ],
    "correctionFeedIds": [
      7777638
    ],
    "stale": false,
    "containsRateUpKey": true,
    "emptyAccepted": false
  },
  "events": [
    {
      "id": 1,
      "startsAt": 1779840000000,
      "endsAt": 1780531199000,
      "dragonNames": [
        "플루모스",
        "클렙토스"
      ],
      "uiPriority": 150
    },
    {
      "id": 2,
      "startsAt": 1780531200000,
      "endsAt": 1781132399000,
      "dragonNames": [
        "네뷸라",
        "포이즌 리버"
      ],
      "uiPriority": 150
    },
    {
      "id": 3,
      "startsAt": 1781136900000,
      "endsAt": 1781740799000,
      "dragonNames": [
        "파루파루",
        "닌자 드래곤"
      ],
      "uiPriority": 150
    }
  ]
}
